<template>
  <ion-page>
    <ion-header class="ion-no-border">
      <ion-toolbar>
        <ion-buttons slot="start">
          <back-button
            :defaultHref="{ name: 'home' }"
            :icon="require('@lib/assets/icons/icon_zurueck.svg')"
            text=""
          >
          </back-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content ref="content" :fullscreen="true">
      <ion-grid fixed class="ion-padding">
        <ion-row>
          <ion-col>
            <div
              class="c-header u-bg-orange"
              :style="{
                'background-image':
                  'url(' +
                  require('@/assets/img/content/icon_roodie_call.svg') +
                  ')',
              }"
            ></div>
            <p>
              <b>So funktioniert's</b>
            </p>
            <p>
              <ion-row>
                <ion-col size="auto">
                  <ion-icon
                    size="large"
                    :src="
                      require('@lib/assets/icons/icon_verlaufskontrolle.svg')
                    "
                  />
                </ion-col>
                <ion-col>
                  &nbsp;<b>1.</b> Ihr Roodie.Check wird mit Ihrer Zustimmung an
                  die ARAG Gesundheitsassistenten übergeben.</ion-col
                >
              </ion-row>
            </p>
            <p>
              <ion-row>
                <ion-col size="auto">
                  <ion-icon
                    size="large"
                    :src="require('@lib/assets/icons/icon_telefon.svg')"
                  />
                </ion-col>
                <ion-col>
                  &nbsp;<b>2.</b> Ein ARAG Gesundheitsassistent kontaktiert Sie
                  telefonisch. Im persönlichen Gespräch wird Ihr Anliegen genau
                  besprochen und Ihre Wünsche werden aufgenommen.
                </ion-col>
              </ion-row>
            </p>
            <p>
              <ion-row>
                <ion-col size="auto">
                  <ion-icon
                    size="large"
                    :src="require('@lib/assets/icons/icon_artzwechsel.svg')"
                  />
                </ion-col>
                <ion-col>
                  &nbsp;<b>3.</b> Ihr ARAG Gesundheitsassistent prüft Ihr
                  Anliegen anhand bestimmter Kriterien und erstellt einen
                  Lösungsansatz für Sie. Er hilft Ihnen auch bei der
                  Organisation der weiterführenden Behandlung.
                </ion-col>
              </ion-row>
            </p>
            <!-- <p>
              <ion-row>
                <ion-col size="auto">
                  <ion-icon
                    size="large"
                    :src="require('@lib/assets/icons/icon_erstdiagnose.svg')"
                  />
                </ion-col>
                <ion-col>
                  &nbsp;<b>4.</b> Am Ende erhalten Sie einen Behandlungsplan und
                  bei Bedarf eine Überweisung, ein Rezept oder eine
                  Arbeitsunfähigkeitsbescheinigung.
                </ion-col>
              </ion-row>
            </p> -->
            <!-- <ion-icon :src="require('@lib/assets/icons/info.svg')" />
            <ion-text color="primary"
              >&nbsp;<b>Hinweis:</b>
              <p>
                Auch wenn sich das ARAG Case Management nicht eignen sollte,
                werden Sie nicht alleine gelassen. Ein ARAG Zahnexperte kümmert
                sich um Ihr Anliegen.
              </p>
            </ion-text> -->
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script>
import { chevronBack } from "ionicons/icons";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonContent,
  IonButton,
  IonGrid,
  IonRow,
  IonCol,
  IonIcon,
  IonButtons,
  IonBackButton,
  // IonText,
} from "@ionic/vue";

export default {
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    IonContent,
    IonButton,
    IonGrid,
    IonRow,
    IonCol,
    IonIcon,
    IonButtons,
    IonBackButton,
    // IonText,
  },
  data() {
    return {};
  },
  setup() {
    return {
      chevronBack,
    };
  },
};
</script>

<style lang="scss" scoped></style>
